import { gql } from '@apollo/client'

import { FRAGMENT as ARTICLE_FRAGMENT } from '../../components/LibraryPostArticleCard'
import { FRAGMENT as VIDEO_FRAGMENT } from '../../components/LibraryPostVideoCard'

export const TUTORIALS = gql`
  query Tutorials($page: Int, $perPage: Int) {
    libraryPosts(page: $page, perPage: $perPage, type: TUTORIAL) {
      nodes {
        ... on LibraryPostArticle {
          ...LibraryPostArticleCardComponent
        }
        ... on LibraryPostVideo {
          ...LibraryPostVideoCardComponent
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }

  ${VIDEO_FRAGMENT}
  ${ARTICLE_FRAGMENT}
`
